import { memo } from 'react';

import DeveloperRoleIconSVG from '@/assets/developer-role-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IDeveloperRoleIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={DeveloperRoleIconSVG} {...props} />
);

export const DeveloperRoleIcon = memo(IDeveloperRoleIcon) as typeof IDeveloperRoleIcon;
